import React from 'react';
import fr from 'facet-rest';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import useCollectionState from 'Hooks/useCollectionState';
import PropTypes from 'prop-types';
import useHomeContext from 'Context/HomeContext';
import { AuthenticationContent } from './AuthenticationContent';

export const AuthenticationContainer = ({ url }) => {
  const { homeResource } = useHomeContext();

  // If you ever show up here and have a user in your home resource then it's time to bounce to the dashboard, which we can
  // do by loading the "User" layout so that everyone goes to the dashboard the same way.
  const authUrl = homeResource.withRelationship(fr.relationships.user.name, (rel) => {
    return rel.link('related').url();
  }, () => {
    return url;
  });

  const {
    collection: authCollection,
    loadingError,
    setCollection,
    isInitialized,
    refreshCollection,
  } = useCollectionState({ link: authUrl });

  return (
    <FullScreenDataContainer
      component={AuthenticationContent}
      componentProps={{
        collection: authCollection,
        authResource: authCollection?.resources().head(),
        setCollection,
        refreshCollection,
      }}
      loading={!isInitialized}
      loadingError={loadingError}
    />
  );
};

AuthenticationContainer.propTypes = {
  url: PropTypes.string.isRequired,
};
